'use client'

import { cn } from '@/shared/lib/classnames'
import { CheckboxWithBorder, useSelectCheckbox } from '@/shared/ui/checkbox'
import { SelectCheckboxProvider } from '../context/select-checkbox-context'
import { useEffect, useId } from 'react'
import { SelectCheckboxSharedProps } from './types'
import { Avatar, AvatarFallback, AvatarImage } from '@/shared/ui/avatar'

export interface ComponentProps extends SelectCheckboxSharedProps {}

function Component({
  options,
  valueFieldName = 'value',
  labelFieldName = 'label',
  idFieldName = 'id',
  imageFieldName = 'image',
  className,
  onChange,
  slots,
  checkboxProps,
  values,
}: ComponentProps) {
  const { onChange: handleOnChange, isChecked, setValues } = useSelectCheckbox()
  const use_id = useId()

  useEffect(() => {
    if (values && setValues) setValues(values)
    if (values === undefined && setValues) setValues([])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values])

  return (
    <div className={cn('flex flex-col gap-2 justify-start w-full', className)}>
      {options.map((item, index) => {
        const label = item?.[labelFieldName]
        const value = String(item?.[valueFieldName] || '')
        const id = item?.[idFieldName]
        const image = item?.[imageFieldName] as string | undefined
        if (!value) return null

        return (
          <CheckboxWithBorder
            {...checkboxProps}
            key={index}
            checked={isChecked && isChecked(value)}
            onCheckedChange={(checked) => {
              handleOnChange &&
                handleOnChange({
                  value,
                  isChecked: !checked,
                  onChangeCallback: (v) => onChange && onChange(v, item),
                })
            }}
            id={(id || value || String(index)) + use_id}
            label={label}
          >
            {image && (
              <Avatar className="h-6 w-6 rounded-none">
                <AvatarImage src={image} />
                <AvatarFallback className="rounded-none">F</AvatarFallback>
              </Avatar>
            )}
          </CheckboxWithBorder>
        )
      })}

      {slots?.errorMessage && slots?.errorMessage}
    </div>
  )
}

export default function ComponentWithProvider({ defaultValues, ...rest }: ComponentProps) {
  return (
    <SelectCheckboxProvider value={{ defaultValues }}>
      <Component defaultValues={defaultValues} {...rest} />
    </SelectCheckboxProvider>
  )
}
